import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { INTEL_OVERVIEW_LAYOUT_ID, INTEL_OVERVIEW_LAYOUT_TEMPLATE_ID } from '../tokens';
import { DEFAULT_INTEL_OVERVIEW_LAYOUT } from './DefaultIntelOverview';

export const DEFAULT_INTEL_OVERVIEW_LAYOUT_SPEC: LayoutSpec = {
  templateId: INTEL_OVERVIEW_LAYOUT_TEMPLATE_ID,
  label: 'Overview',
  id: INTEL_OVERVIEW_LAYOUT_ID,
  dockViewLayout: DEFAULT_INTEL_OVERVIEW_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
